import { render, staticRenderFns } from "./App.vue?vue&type=template&id=18e02afc&scoped=true&lang=html&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "@/assets/colors.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./App.vue?vue&type=style&index=1&id=18e02afc&prod&lang=scss&"
import style2 from "./App.vue?vue&type=style&index=2&id=18e02afc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e02afc",
  null
  
)

export default component.exports